/**
 * Company: SPHMedia
 * Description: [Follow topics Toast Message Component]
 */

import Cross from "@assets/icons/close.svg";
import SuccessIcon from "@assets/icons/success-green.svg";
import {
  FOLLOW_TOPIC_TOAST_MESSAGE_COPY,
  MYBH_LINK,
} from "@config/followTopic";
import { ReactElement } from "react";

import useFollowTopicsToast from "./hooks/useFollowTopicsToast";

type FollowTopicsToastMessageProps = {
  forceShowToast?: boolean;
};

/**
 * FollowTopicsToastMessage
 * Description: [Toast message component for displaying follow topic notifications]
 * @param props - The props required by the component (if any)
 * @returns The rendered React element
 */
export default function FollowTopicsToastMessage({
  forceShowToast,
}: FollowTopicsToastMessageProps): ReactElement {
  const { hide, handleClose } = useFollowTopicsToast({ forceShowToast });

  return (
    <div
      data-testid="follow-topics-success-toast"
      className={`fixed left-1/2 -translate-x-1/2 z-[99] top-[calc(var(--newStickyHeight,0px)+env(safe-area-inset-top,0px)+8px)]
      flex w-full justify-between items-center py-2 px-3 max-w-[358px] bg-blue-450 
      rounded-[8px] shadow-[0_0_12px_0_rgba(0,0,0,0.5)] transition-all duration-500 ease-in-out
      ${hide ? "opacity-0 translate-y-4 pointer-events-none" : "opacity-100 translate-y-0"}
    `}
    >
      <div data-testid="toast-icon" className="flex items-center">
        <img src={SuccessIcon} alt="success-icon" width={24} />
      </div>
      <div
        data-testid="toast-message"
        className="flex gap-2 items-center text-xs text-text-inverse"
      >
        <p className="font-medium leading-[150%] ">
          {FOLLOW_TOPIC_TOAST_MESSAGE_COPY}
        </p>
        <a
          href={`/${MYBH_LINK}`}
          className="py-1.5 px-2.5 font-regular leading-[120%] border border-neutral-0 rounded-full"
        >
          Pergi ke BHku
        </a>
      </div>
      <div className="flex items-center">
        <button
          data-testid="toast-close-button"
          onClick={() => {
            handleClose();
          }}
        >
          <img src={Cross} alt="close-icon" width={16} />
        </button>
      </div>
    </div>
  );
}
